import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen bg-white text-slate-800 antialiased">
        <ScrollToTop />
        <Header />
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/ydelser" element={<Services />} />
            <Route path="/ydelser/:slug" element={<ServiceDetail />} />
            <Route path="/referencer" element={<Projects />} />
            <Route path="/referencer/:slug" element={<ProjectDetail />} />
            <Route path="/galleri" element={<Gallery />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </HelmetProvider>
  );
}
